import { TILE_SIZE } from "@components/core/theme";
import { Vector2 } from "@utility/vector2";

export const W = 140;
export const H = 36;
const TX = TILE_SIZE.x;
const TY = TILE_SIZE.y;

// Adjacent offsets to check: diagonals preferred over orthogonal
export const CANDIDATE_OFFSETS: Vector2[] = [
    new Vector2(1, -1),  // top-right
    new Vector2(-1, -1), // top-left
    new Vector2(1,  1),  // bottom-right
    new Vector2(-1,  1), // bottom-left
    new Vector2(1,  0),  // right
    new Vector2(-1,  0), // left
    new Vector2(0, -1),  // above
    new Vector2(0,  1),  // below
];

// Returns the circle centre in SVG-local coordinates for the dot that marks
// the corner/edge of the anchor tile closest to the label.
// svgW, left, top must match labelLayout output for the same (dx, dy).
export function dotInSvg(dx: number, dy: number, svgW: number, svgLeft: number, svgTop: number,
                  px: number, py: number): { cx: number; cy: number } {
    const wx = dx > 0 ? px + TX : dx < 0 ? px : px + TX / 2;
    const wy = dy < 0 ? py       : dy > 0 ? py + TY : py + TY / 2;
    return { cx: wx - svgLeft, cy: wy - svgTop };
}

// Returns { svgW, pathD, left, top } for the label SVG given the chosen offset direction
// and the anchor tile's pixel-space origin (px, py).
export function labelLayout(dx: number, dy: number, px: number, py: number) {
    if (dx > 0) {
        const pathD = dy === 0
            ? `M 0,${H / 2 + 3} Q ${W * 0.5},${H / 2 - 12} ${W},${H / 2}`
            : dy < 0
                ? `M 0,${H - 4} Q ${W * 0.5},${H / 2 - 10} ${W},4`
                : `M 0,4 Q ${W * 0.5},${H / 2 + 10} ${W},${H - 4}`;
        const top = dy === 0 ? py + TY / 2 - H / 2
            : dy < 0         ? py - H - 4
                             : py + TY + 4;
        return { svgW: W, pathD, left: px + TX + 8, top };
    }

    if (dx < 0) {
        const pathD = dy === 0
            ? `M 0,${H / 2 + 3} Q ${TX * 0.5},${H / 2 - 12} ${TX},${H / 2}`
            : dy < 0
                ? `M 0,4 Q ${TX * 0.5},${H / 2 - 10} ${TX},${H - 4}`
                : `M 0,${H - 4} Q ${TX * 0.5},${H / 2 + 10} ${TX},4`;
        const top = dy === 0 ? py + TY / 2 - H / 2
            : dy < 0         ? py - H - 4
                             : py + TY + 4;
        return { svgW: TX, pathD, left: px - TX - 8, top };
    }

    if (dy < 0) {
        // Tile above — arc ends at dot (centre of tile's top edge, = SVG bottom centre)
        return {
            svgW:  W,
            pathD: `M 4,8 Q ${W * 0.35},${H * 0.7} ${W / 2},${H}`,
            left:  px + TX / 2 - W / 2,
            top:   py - H,
        };
    }

    // Tile below — arc starts at dot (centre of tile's bottom edge, = SVG top centre)
    return {
        svgW:  W,
        pathD: `M ${W / 2},0 Q ${W * 0.8},${H * 0.45} ${W - 4},${H - 8}`,
        left:  px + TX / 2 - W / 2,
        top:   py + TY,
    };
}
